import UIDialog from "../ui/dialog_controller.js";
import "@kanety/stimulus-static-actions";

export default class extends UIDialog {
  static targets = [
    "dialog",
    "modal",
    "focus",
    "drag",
    "backdrop",
    "closeButton",
    "loaderTemplate",
    "content"
  ];
  static values = { href: String, open: Boolean };

  connect() {
    if (this.openValue) {
      this.openBy(this.element);
    }
  }

  open(e) {
    if (e) e.preventDefault();

    this.openBy(this.element);

    if (this.hrefValue) {
      const contentDiv = this.contentTarget;
      const loaderTemplate = this.hasLoaderTemplateTarget ? this.loaderTemplateTarget : null;

      if (contentDiv && loaderTemplate) {
        const loaderClone = loaderTemplate.content.cloneNode(true);
        contentDiv.innerHTML = "";
        contentDiv.appendChild(loaderClone);
      }

      $.ajax({
        url: this.hrefValue,
        method: "GET",
        dataType: "script",
      });
    }
  }

  close(e) {
    if (e) e.preventDefault();
    this.closeBy(this.element);
  }

  openBy(target) {
    this.toggleClass(true);

    if (this.hasFocusTarget) {
      this.focusTarget.focus();
    }

    this.dispatch("opened", { detail: { target } });
  }

  closeBy(target) {
    this.toggleClass(false);

    this.dispatch("closed", { detail: { target } });
  }

  toggleClass(visible) {
    if (visible) {
      this.dialogTarget.classList.remove("tw-hidden");
      this.dialogTarget.dataset.state = "open";

      if (this.hasModalTarget) {
        this.modalTarget.classList.remove("tw-hidden");
        this.modalTarget.dataset.state = "open";
      }

      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.remove("tw-hidden");
        this.backdropTarget.dataset.state = "open";
      }

      document.body.classList.add("tw-overflow-hidden");
      if (this.hasContentTarget) {
        this.contentTarget.classList.add("tw-overflow-y-scroll", "tw-h-full");
      }
    } else {
      this.dialogTarget.dataset.state = "closed";

      setTimeout(() => {
        this.dialogTarget.classList.add("tw-hidden");

        if (this.hasModalTarget) {
          this.modalTarget.classList.add("tw-hidden");
          this.modalTarget.dataset.state = "closed";
        }

        if (this.hasBackdropTarget) {
          this.backdropTarget.classList.add("tw-hidden");
          this.backdropTarget.dataset.state = "closed";
        }

        document.body.classList.remove("tw-overflow-hidden");
        if (this.hasContentTarget) {
          this.contentTarget.classList.remove("tw-overflow-y-scroll", "tw-h-full");
        }
      }, 120);
    }
  }

  closeByKey(e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      this.closeBy(this.element);
      e.preventDefault();
    }
  }

  closeByModal(e) {
    if (!this.dialogTarget.contains(e.target)) {
      this.closeBy(this.element);
    }
  }
}
